export default __webpack_public_path__ + "static/media/263705.21f637c6.png";